import { SCHEDULES_PART01 } from './schedules.part01.js'
import { SCHEDULES_PART02 } from './schedules.part02.js'
import { SCHEDULES_PART03 } from './schedules.part03.js'

/** Sample schedules shown under Mine. Every cadence tab has at least one. */
export const DEMO_SCHEDULES = [...SCHEDULES_PART01, ...SCHEDULES_PART02, ...SCHEDULES_PART03]
